<ng-template #askingDetailsModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Personal Details</h4>
        <button type="button" class="btn-close" aria-label="Close" title="Close Modal" (click)="modal.dismiss('Cross click')"
            title="Close Modal"></button>
    </div>
    <div class="modal-body">
        <h5 class="modal-info-text light">We need your personal details so our partners can
            deliver your orders.</h5>
        <h5 class="modal-info-text light">
            You can fill this out now or when you are ready to make a purchase
        </h5>
        <div class="btn-grps">
            <app-button [btnText]="'Enter Details'" [btnTitle]="'Enter Details'"
                [btnCss]="'btn btn-primary w-100 btn-lg'"
                (onBtnClick)="openModal(profileComponent.profileTemplate, 'add-profile-modal'); modal.close('Close click');"></app-button>
            <app-button [btnText]="'Not Now'" [btnTitle]="'Not Now'" [btnCss]="'btn btn-text w-100 btn-lg btn-md'"
                (onBtnClick)="notNowClicked();modal.close('Close click');"></app-button>
        </div>
    </div>
</ng-template>

<app-profile #profileModal></app-profile>
<app-registration-done #registrationDoneModal></app-registration-done>